import Customers from './Customers';

export default Customers;


// WEBPACK FOOTER //
// ./src/views/Customers/index.js